import { apiRequest } from "./client";

export interface GuestbookEntry {
  id: string;
  name: string;
  message: string;
  createdAt: number;
}

export const MAX_GUESTBOOK_MESSAGE_LENGTH = 600;
export const MAX_GUESTBOOK_NAME_LENGTH = 60;

export function fetchGuestbook(): Promise<GuestbookEntry[]> {
  return apiRequest<GuestbookEntry[]>("/api/guestbook");
}

export function postGuestbookEntry(name: string, message: string): Promise<GuestbookEntry> {
  return apiRequest<GuestbookEntry>("/api/guestbook", { method: "POST", body: JSON.stringify({ name, message }) });
}
